import { isEqualString } from '@/common/utils'
import constate from 'constate'
import dayjs from 'dayjs'
import { useMemo } from 'react'
import { EndTimeTypeEnum } from '../utils'
import { RulePackageRes } from '../utils/types'

// 1️⃣ Create a custom hook that receives props

interface Props {
  formStatus: { isCreate: boolean, isEdit: boolean }
  ruleData?: RulePackageRes
}


function useFormState (props:Props) {
  const { ruleData } = props
  const ruleEffectStatus: RuleEffectStatusEnum = useMemo(() => {
    if (props.formStatus?.isCreate || !ruleData) return RuleEffectStatusEnum.NotStart
    const { effectiveTimeRule } = ruleData
    const now = dayjs()
    const startTime = effectiveTimeRule?.startTime
    const endTime = effectiveTimeRule?.endTime
    if (now.isBefore(startTime)) { // 未开始
      return  RuleEffectStatusEnum.NotStart
    } else if (!isEqualString(effectiveTimeRule.endTimeType, EndTimeTypeEnum.PERMANENT) && endTime && now.isAfter(endTime)) { // 已结束
      return  RuleEffectStatusEnum.Expired
    } else {
      return  RuleEffectStatusEnum.InProgress // 进行中
    }
  }, [ruleData, props.formStatus?.isCreate])

  const effectStatusMap = {
    isNotStart: ruleEffectStatus === RuleEffectStatusEnum.NotStart,
    isExpired: ruleEffectStatus === RuleEffectStatusEnum.Expired,
    isInProgress: ruleEffectStatus === RuleEffectStatusEnum.InProgress,
  }

  return {
    /** 生效状态 */
    ruleEffectStatus,
    effectStatusMap,
    ruleData,
    formStatus: props.formStatus,
  }
}

// NOTE: 注意解构的顺序
const [
  FormContextProvider,
  useFormContext,
] = constate(
  useFormState,
  value => value,
)

export enum RuleEffectStatusEnum {
  /** 未开始 */
  NotStart = 'notStart',
  /** 已失效 */
  Expired = 'expired',
  /** 进行中 */
  InProgress = 'inProgress',
}

export {
  FormContextProvider, useFormContext,
}

export default {  FormContextProvider, useFormContext }
